export function replacePlaceholdersInString(inputString: string, valuesObject: Record<string, string>) {
  // Use a regular expression to match placeholders like "{key}"
  return inputString.replace(/\{(\w+)\}/g, (match, key) => {
    // Check if the key exists in the valuesObject and replace it
    return valuesObject.hasOwnProperty(key) ? valuesObject[key] : match;
  });
}
